import React, { useContext } from 'react';
import CartContext from '../../app/CartContext';

function TournoiCard({ tournoi }) { // Destructure tournoi from props directly
    const cart = useContext(CartContext);

    function handleAddToCart() {
        cart.addItem(tournoi); // Pass the tournoi object, not props
    }

    return (
        <>
            <div className="card mb-4 rounded-3 shadow-sm">
                <div className="card-header py-3">
                    <h4 className="my-0 fw-normal">{tournoi.title}</h4>
                </div>
                <div className="card-body">
                    <h1 className="card-title pricing-card-title">
                        ${tournoi.price}
                        <small className="text-body-secondary fw-light">/mo</small>
                    </h1>
                    <ul className="list-unstyled mt-3 mb-4">
                        <li>10 users included</li>
                        <li>2 GB of storage</li>
                        <li>Email support</li>
                        <li>Help center access</li>
                    </ul>
                    <button
                        type="button"
                        className="w-100 btn btn-lg btn-outline-primary"
                        onClick={handleAddToCart}
                    >
                        Add To Cart
                    </button>
                </div>
            </div>
        </>
    );
}

export default TournoiCard;